<template>
    <div id="quiz" class="container flex-grow-1 pt-5 d-flex flex-column">
      <div class="align-items-center" v-if="question_displayed">
        <div class="card animated fadeInLeftBig" >
          <div class="card-body">
            <div class="introduction_text mb-2" v-if="!presentation_mode" v-html="current_question.introduction_text"></div>
            <div class="question_text" v-html="current_question.question_text"></div>
          </div>
        </div>
      </div>

      <div class="row justify-content-center align-items-center mt-5 mb-5 no-select flex-grow-1" v-if="question_displayed">
        <div class="col-sm-8">
            <div class="btn btn-outline-primary btn-block btn-xl btn-answer animated duration-05 fadeInDown"
               v-bind:style="{ animationDelay: presentation_mode ? '0s' : (index/7) + 0.6 + 's' }"
               v-bind:class="[getAnswerResultClass(item), getPresentationModeAnswerDisplay(index)]"
               @click="submitAnswer(item)"
               v-for="(item, index) in current_question.answers" v-bind:key="index" v-bind:item="item" v-bind:index="index">
              {{item}}
            <font-awesome-icon v-if="current_question_answered" class="answer-icon" :icon="getAnswerResultIcon(item)" /></div>
        </div>
      </div>

      <div class="align-items-center d-flex" v-if="link_text_displayed && current_question.link_text !== ''" v-bind:class="{'flex-grow-1': current_question.image === ''}">
        <div>
        <div class="card">
          <div class="card-body">
            <div class="question_text" v-html="current_question.link_text"></div>
          </div>
        </div>
        </div>
      </div>

      <div v-if="link_text_displayed && current_question.image !== ''" class=" pt-5 pb-5 flex-grow-1 d-flex justify-content-center align-items-center flex-column img-items-flex">

        <video v-if="current_image_is_video" id="the-video" v-bind:autoplay="!presentation_mode" class="d-flex flex-grow-image w-auto " style="max-width:100%;min-width:400px;" v-bind:class="{'video-fullscreen':video_fullscreen}"  loop="" @click="toggleVideoFullscreen"> <source :src="current_image" type="video/mp4"> </video>

        <img v-if="!current_image_is_video" :src="current_image" class="d-flex w-auto flex-grow-image">
      </div>
      <div class="d-flex align-items-end mb-5 mt-3">
        <div class="d-flex w-100">
          <router-link to="/results" class="btn btn-outline-secondary btn-md" v-bind:class="{'mr-auto':current_question_answered}" v-if="current_question_index > 0 || current_question_answered">{{ $t('Final result') }}</router-link>
          <button class="btn btn-outline-secondary btn-md mr-auto" v-if="!current_question_answered" @click="toNextQuestionOrResults">{{ $t('Skip question') }}</button>
          <button class="btn btn-outline-primary btn-md mr-auto ml-auto" v-if="current_question_answered" data-toggle="popover">{{ $t('More info') }}</button>
          <button class="btn btn-primary btn-md ml-auto" v-if="current_question_answered" @click="continueQuiz">{{ $t('Continue') }}</button>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import { faCheckCircle, faTimesCircle } from '@fortawesome/fontawesome-free-regular'

export default {
  name: 'Quiz',
  components: {FontAwesomeIcon},
  data () {
    return {
      questions_total: 0,
      current_answer: '',
      question_displayed: 1,
      link_text_displayed: 0,
      current_question_index: 0,
      answers_displayed: 0,
      video_fullscreen: 0
    }
  },
  computed: {
    ...mapGetters({
      questions: 'getSelectedQuestions',
      correct_answered: 'getCorrectAnswered',
      presentation_mode: 'getPresentationMode'
    }),
    current_image_is_video (vm) {
      let image = vm.questions[vm.current_question_index].image
      return image !== '' && image.split('.').pop() === 'mp4'
    },
    current_question: vm => vm.questions[vm.current_question_index],
    current_image: vm => vm.questions[vm.current_question_index].image,
    current_question_answered: vm => vm.current_answer !== ''
  },
  created () {
    if (this.presentation_mode) {
      document.addEventListener('click', this.clickOnBody)
    }
    this.$store.dispatch('resetCorrectAnsweredCount')
    this.questions_total = this.questions.length
    this.setNavigationParams()
  },
  methods: {
    toggleVideoFullscreen () {
      let theVideo = document.getElementById('the-video')
      if (this.video_fullscreen === 0) {
        this.video_fullscreen = 1
        theVideo.play()
      } else {
        this.video_fullscreen = 0
        theVideo.pause()
      }
    },
    setNavigationParams () {
      let currQuestionCount = Number.parseInt((Number.parseInt(this.current_question_index) + 1))
      this.$store.dispatch('setNavTitle', this.$i18n.t('Question', this.$i18n.locale) + ' ' + currQuestionCount)
      this.$store.dispatch('setNavSubtitle', this.$i18n.t('of', this.$i18n.locale) + ' ' + this.questions_total)
      this.$store.dispatch('setNavInfo', this.current_question.topics.join(', '))
    },
    getAnswerResultClass (item) {
      if (!this.current_question_answered) return ''
      if (item === this.current_question.answer) {
        return 'correct_answer is_answered'
      } else {
        if (item === this.current_answer) {
          return 'wrong_answer selected_answer is_answered'
        } else {
          return 'wrong_answer  is_answered'
        }
      }
    },
    getPresentationModeAnswerDisplay (index) {
      if (!this.presentation_mode) return ''
      return (index) < this.answers_displayed ? '' : 'd-none'
    },
    clickOnBody () {
      if (this.question_displayed && this.answers_displayed < this.current_question.answers.length) {
        this.answers_displayed++
      }
    },
    getAnswerResultIcon (item) {
      if (!this.current_question_answered) return null
      if (item === this.current_question.answer) {
        return faCheckCircle
      } else {
        return faTimesCircle
      }
    },
    submitAnswer (answer) {
      if (this.presentation_mode && this.answers_displayed < this.current_question.answers.length) return

      this.current_answer = answer

      if (answer === this.current_question.answer) this.$store.dispatch('incrementCorrectCount')

      this.$nextTick(function () {
        window.$('[data-toggle="popover"]').popover({
          content: this.current_question.feedback_text,
          html: true,
          placement: 'top',
          container: 'body',
          trigger: 'hover focus'
        })
      })
    },
    toNextQuestionOrResults () {
      window.$('[data-toggle="popover"]').popover('dispose')
      if ((this.current_question_index + 1) === this.questions_total) {
        this.$router.push('/results')
      } else {
        this.current_question_index++
        this.current_answer = ''
        this.link_text_displayed = 0
        setTimeout(() => { this.question_displayed = 1 }, 0)

        if (this.presentation_mode) {
          setTimeout(() => { this.answers_displayed = 0 }, 0)
        }
        this.setNavigationParams()
      }
    },
    continueQuiz () {
      if (this.question_displayed === 0) {
        this.toNextQuestionOrResults()
      } else {
        if (this.current_question.link_text !== '' || this.current_question.image !== '') {
          this.question_displayed = 0
          this.link_text_displayed = 1
        } else {
          this.toNextQuestionOrResults()
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Quiz.vue